
import React from "react";
import { Link } from "react-router-dom";

// Header function
const Header = () => {

  return (
    <React.Fragment>
      <header id="page-topbar">
        <div className="navbar-header">
          <div className="d-flex">
            <div className="navbar-brand-box text-center">
              <Link to="/" className="logo logo-dark">
                <span className="logo-sm">
                  {/* <img src={logo} alt="logo-sm-dark" height="22" /> */}
                </span>
                <span className="logo-lg">
                  {/* <img src={logo} alt="logo-dark" height="24" /> */}
                </span>
              </Link>

              <Link to="/" className="logo logo-light">
                <span className="logo-sm">
                {/* <img src={logo} alt="logo-sm-dark" height="22" /> */}
                </span>
                <span className="logo-lg">
                  {/* <img src={logo} alt="logo-light" height="60" /> */}
                </span>
              </Link>
            </div>

            <button
              type="button"
              className="btn btn-sm px-3 font-size-24 header-item waves-effect"
              id="vertical-menu-btn"
            >
              <i className="ri-menu-2-line align-middle"></i>
            </button>
          </div>

          <div className="d-flex">
            <div className="dropdown d-inline-block d-lg-none ms-2">
              <button
                type="button"
                className="btn header-item noti-icon "
                id="page-header-search-dropdown"
              >
                {/* <i className="ri-search-line" /> */}
              </button>
              <div
                // className={
                //   search
                //     ? "dropdown-menu dropdown-menu-lg dropdown-menu-end p-0 show"
                //     : "dropdown-menu dropdown-menu-lg dropdown-menu-end p-0"
                // }
                // aria-labelledby="page-header-search-dropdown"
              >
                {/* <form className="p-3">
                  <div className="form-group m-0">
                    <div className="input-group">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Search ..."
                        aria-label="Recipient's username"
                      />
                      <div className="input-group-append">
                        <button className="btn btn-primary" type="submit">
                          <i className="ri-search-line" />
                        </button>
                      </div>
                    </div>
                  </div>
                </form> */}
              </div>
            </div>

            {/* <LanguageDropdown /> */}
            {/* <AppsDropdown /> */}

            <div className="dropdown d-none d-lg-inline-block ms-1">
              <button
                type="button"
                // onClick={() => {
                //   toggleFullscreen();
                // }}
                className="btn header-item noti-icon"
                data-toggle="fullscreen"
              >
                <i className="ri-fullscreen-line" />
              </button>
            </div>
          </div>
        </div>
      </header>
    </React.Fragment>
  );
};

export default Header;
